import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { DriveRegister } = await import('@containers/Drive/Register/index');
    return {
        Component: DriveRegister,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
